'use strict';

angular.module('app')
  .directive('tripadvisorRating', function() {
    return {
      restrict: 'E',
      scope: {
        ratingValue: '@',
        ratingClass: '@'
      },
      replace: true,
      template: '<div class="tripadvisor-rating {{ratingClass}}">' +
        '<ul>' +
        '<li ng-repeat="item in createArr(ratingValue) track by $index" ng-class="{ full: item == 1, half: item == 0.5}"></li>' +
        '</ul>' +
        '</div>',
      link: function(scope, element, attrs) {
        scope.createArr = function(integer) {
          var some = integer.split('.'),
            arr = [];

          for (var i = 1; i <= some[0]; i++) {
            arr.push(1);
          }

          if (some[1]) {
            arr.push('0.' + some[1]);
          }

          if (arr.length < 5) {
            for (var i = arr.length; i < 5; i++) {
              arr.push('');
            }
          }

          return arr;
        }
      }
    };
  });